import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: () => import("@/index")
  }, {
    path: '/login',
    name: 'login',
    component: () => import("@/login")
  }, {
    path: '*',
    redirect: '/index'
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js